// Tema da vitrine a partir de uma cor (#rrggbb escolhida pela locadora).
// Gera as variáveis CSS usadas em ShowcaseView: a cor, uma segunda cor para o
// gradiente (matiz deslocado), um fundo suave e a cor do anel de foco.

export const COR_PADRAO = '#7c3aed';

export const CORES_SUGERIDAS = [
  '#7c3aed', '#db2777', '#e11d48', '#ea580c', '#d97706',
  '#16a34a', '#0d9488', '#0284c7', '#2563eb', '#0f172a',
];

function hexParaRgb(hex) {
  const n = parseInt(hex.slice(1), 16);
  return [(n >> 16) & 255, (n >> 8) & 255, n & 255];
}

function rgbParaHsl([r, g, b]) {
  r /= 255; g /= 255; b /= 255;
  const max = Math.max(r, g, b);
  const min = Math.min(r, g, b);
  const l = (max + min) / 2;
  if (max === min) return [0, 0, l * 100];
  const d = max - min;
  const s = l > 0.5 ? d / (2 - max - min) : d / (max + min);
  let h;
  if (max === r) h = (g - b) / d + (g < b ? 6 : 0);
  else if (max === g) h = (b - r) / d + 2;
  else h = (r - g) / d + 4;
  return [h * 60, s * 100, l * 100];
}

function valida(hex) {
  return typeof hex === 'string' && /^#[0-9a-fA-F]{6}$/.test(hex) ? hex : COR_PADRAO;
}

export function temaVitrine(cor) {
  const hex = valida(cor);
  const rgb = hexParaRgb(hex);
  const [h, s, l] = rgbParaHsl(rgb);
  // Cores muito escuras/neutras (ex.: preto) não ganham segundo matiz colorido
  const segunda = s < 15
    ? `hsl(${h}, ${s}%, ${Math.min(l + 18, 60)}%)`
    : `hsl(${(h + 35) % 360}, ${Math.min(s + 5, 95)}%, ${Math.min(Math.max(l, 45), 60)}%)`;

  return {
    '--sc-accent': hex,
    '--sc-accent-2': segunda,
    '--sc-accent-soft': `rgba(${rgb.join(', ')}, .12)`,
    '--sc-accent-ring': `rgba(${rgb.join(', ')}, .2)`,
  };
}
